'use client';

import React from 'react';
import { useIdPath } from '@/contexts/IdPathProvider';
import { FileManager } from '../../index';
import type { S3Object } from '../../variants/default/utils/services/fileManager';

interface FileManagerWrapperProps {
    onClose: () => void;
    isSidebarOpen: boolean;
}

export default function FileManagerWrapper({ onClose, isSidebarOpen }: FileManagerWrapperProps) {
    const { idPath, namePath } = useIdPath();
    
    const handleFileSelect = (file: S3Object) => {
        console.log('File selected:', file);
        // Có thể thêm logic khác ở đây như mở preview, copy URL, etc.
        
        // Show notification hoặc toast
        alert(`Đã chọn ${file.isFolder ? 'folder' : 'file'}: ${file.name}`);
    };

    return (
        <div className="h-full bg-gray-50 z-100 w-full" style={{ position: 'absolute' }}>
            {/* Header */}
            <div className="bg-white border-b border-gray-200 px-6 py-4">
                <div className="flex items-center justify-between">
                    <h1 className="text-2xl font-semibold text-gray-900">
                        Quản lý File & Folder
                    </h1>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700 p-2 rounded-lg hover:bg-gray-100 transition-colors"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            </div>

            {/* Content */}
            <div className="h-[calc(100%-73px)] overflow-hidden">
                {/* <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                    <p className="text-blue-800">Debug Info:</p>
                    <p className="text-sm text-blue-600">namePath: {namePath || "undefined"}</p>
                    <p className="text-sm text-blue-600">idPath: {idPath || "undefined"}</p>
                </div> */}
                
                <FileManager 
                    namepath={namePath || "viet-nam-34-tinh"}
                    onFileSelect={handleFileSelect}
                    allowUpload={true}
                    allowDelete={true}
                    allowDownload={true}
                />
            </div>
        </div>
    );
}
